import React from 'react';
import { useTranslation } from 'react-i18next';

import './GrowTogether.css';

const PARTNER_IMAGE =
  'https://haatnexusprodinfosys.blob.core.windows.net/images/1785047406427-391738611.webp';

interface GrowTogetherProps {
  /** Called when the primary "Get started" CTA is clicked. */
  onStart?: () => void;
}

/**
 * Mid-page CTA banner. Partner image is anchored to the bottom-right corner.
 */
const GrowTogether: React.FC<GrowTogetherProps> = ({ onStart }) => {
  const { t } = useTranslation();

  return (
    <section className="grow-together">
      <div className="hero">
        <div className="hero__bg" aria-hidden="true" />
        <img
          className="hero__image"
          src={PARTNER_IMAGE}
          alt={t('landingSections.growTogether.alt') as string}
        />
        <div className="hero__content">
          <h1 className="hero__title">
            {t('landingSections.growTogether.title')}
          </h1>
          <p className="hero__subtitle">
            {t('landingSections.growTogether.subtitle')}
          </p>
          <button type="button" className="hero__cta" onClick={onStart}>
            {t('landingSections.growTogether.cta')}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default GrowTogether;
